import { AssetCategory, AssetType } from './types';

export interface CampaignTemplateAsset {
  category: AssetCategory;
  asset_type: AssetType;
  /** Suffix appended to the campaign name to form the asset title. */
  title_suffix: string;
}

export interface CampaignTemplate {
  id: string;
  name: string;
  description?: string;
  assets: CampaignTemplateAsset[];
}

/** Starter templates Doreen can apply to a campaign in one click. The list
 *  is kept small on purpose — extend here when she identifies a new pattern
 *  worth a one-click setup. */
export const CAMPAIGN_TEMPLATES: CampaignTemplate[] = [
  {
    id: 'standard',
    name: 'Standard campaign',
    description: 'IG post, IG story, Newsletter, Homepage banner, Homepage product grid.',
    assets: [
      { category: 'Social Media', asset_type: 'Instagram Post', title_suffix: 'IG Post' },
      { category: 'Social Media', asset_type: 'Instagram Story', title_suffix: 'IG Story' },
      { category: 'Email', asset_type: 'Newsletter', title_suffix: 'Newsletter' },
      { category: 'Homepage', asset_type: 'Hero Banner 100%', title_suffix: 'Hero Banner' },
      { category: 'Homepage', asset_type: 'Homepage Product Grid', title_suffix: 'Homepage Product Grid' },
    ],
  },
];
